import { FormProvider } from "./contexts/FormContext";
import { CalibrationProvider } from "./contexts/CalibrationContext";
import { ShedConfigProvider } from "./contexts/ShedConfigContext";
import AppContainer from "./components/layout/AppContainer";
import BasicInfoForm from "./components/forms/BasicInfoForm";
import SurveyUpload from "./components/survey/SurveyUpload";
import CalibrationSection from "./components/survey/CalibrationSection";
import ShedConfigurationSection from "./components/configuration/ShedConfigurationSection";
import ShedVisualization from "./components/visualization/ShedVisualization";
import WindAnchoringSection from "./components/extras/WindAnchoringSection";
import ShinglesSection from "./components/shingles/ShinglesSection";
import GenerateReportSection from "./components/report/GenerateReportSection";
import ConfigDrawer from "./components/configuration/ConfigDrawer";
import PlacementConfirmModal from "./components/modals/PlacementConfirmModal";
import PdfDownloadConfirmModal from "./components/modals/PdfDownloadConfirmModal";
import LoadingOverlay from "./components/report/LoadingOverlay";
import { DashboardLayout } from "@/components/layout/DashboardLayout";

export default function Configurator() {
  return (
    <DashboardLayout>
      <FormProvider>
        <CalibrationProvider>
          <ShedConfigProvider>
            <AppContainer>
              {/* 1. Basic Information */}
              <BasicInfoForm />

              {/* 2. Survey Upload */}
              <SurveyUpload />

              {/* 3. Calibration and Shed Location */}
              <CalibrationSection />

              {/* 4. Shed Configuration and Installation */}
              <ShedConfigurationSection />

              {/* 5. Shed Visualization */}
              <ShedVisualization />

              {/* 6. Wind, Anchoring and Materials */}
              <WindAnchoringSection />

              {/* 7. Shingles */}
              <ShinglesSection />

              {/* 8. Generate Report */}
              <GenerateReportSection />
            </AppContainer>

            {/* Drawer (slide-over panel) */}
            <ConfigDrawer />

            {/* Modals */}
            <PlacementConfirmModal />
            <PdfDownloadConfirmModal />
            <LoadingOverlay />
          </ShedConfigProvider>
        </CalibrationProvider>
      </FormProvider>
    </DashboardLayout>
  );
}
